var map = {
	"./Footer_Desktop.jpg": 423,
	"./Footer_Tablet.jpg": 424,
	"./Footer_mobile.jpg": 425,
	"./playbtn.svg": 426,
	"./video_1_img.jpg": 427,
	"./video_2_img.jpg": 428
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 422;